import { storeToRefs } from 'pinia';
import { useUnitsStore } from 'stores/units-store';
import { useDataDictionary } from './useDataDictionary';

/**
 * Resolves a unit from the client-side units data dictionary by its `id`,
 * avoiding the need for the back end to embed a resolved unit object in every
 * response. Returns the dictionary entry (`unit_name`, `unit_number`,
 * `unit_type_id`, …) or `null` when the id is unknown.
 */
export function useUnitLookup() {
  const { dataDictionary } = storeToRefs(useUnitsStore());
  const { get: getUnit, byId } = useDataDictionary(dataDictionary);

  return { getUnit, unitsById: byId };
}
